import { ContactInformation } from '..';

export interface CustomerSupport {
    asic: ContactInformation;
    cysec?: ContactInformation;
    fca?: ContactInformation;
    scb?: ContactInformation;
    svg?: ContactInformation;
    vfsc?: ContactInformation;
}
